import React from 'react';
const BASENAME = process.env.PUBLIC_URL;

const ProjectRender = (params) => {
    const {value, data} = params;
    const {id} = data;

    return (
        <div className={"text-blue-700 w-full hover:underline"} onClick={() => window.open(`${BASENAME}/projects/form/${id}`)}>
            {value}
        </div>
    );
};

export default ProjectRender;